<template>
  <div>
    <p :class="$style.text">{{questions[$props.currentQuestion].title}}</p>
    <ul :class="$style.list">
      <li v-for="(answer, index) in questions[$props.currentQuestion].answers" :key="index" :class="$style.item">
        <input type="checkbox" :class="$style.inputCheckbox" :id="`checkbox${index}`" :value="index + 1" v-model="checkedArr">
        <label :for="`checkbox${index}`" :class="$style.label">{{answer}}</label>
      </li>
    </ul>
    <v-btn @click="checkAnswer" :class="$style.btn">Ответить</v-btn>
    <p v-if="isWrong" :class="$style.wrong">Неверный ответ! Попробуй еще раз.</p>
  </div>
</template>

<script>
import {
  ref, watch,
} from 'vue'
import questions from '../questions'

export default {
  name: 'classic-multiple',
  emits: ['next'],
  props: {
    currentQuestion: {
      type: Number,
    },
  },
  setup(props, { emit }) {
    const isWrong = ref(false)
    const checkedArr = ref([])

    watch(checkedArr, () => {
      isWrong.value = false
    })

    const checkAnswer = () => {
      isWrong.value = [...checkedArr.value].sort((a, b) => a - b).join('') !== questions[props.currentQuestion].rightAnswer
      if (isWrong.value) return false
      emit('next')
      return false
    }

    return {
      questions,
      checkAnswer,
      isWrong,
      checkedArr,
    }
  },
}
</script>

<style lang="scss" module src="./classicMultiple.scss"></style>
